import request from 'superagent'
import {itsmMySpacesApi} from '@/modules/ITSM/api/generate-itsm-api-url'

export const getChannels = async headers => {
  return await request.get(itsmMySpacesApi().getSpaces).set(headers)
}
